// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1dYW2","buttons":"SendReceipts_buttons__3Vscu","email":"SendReceipts_email__11Pir","bookApptTitle":"SendReceipts_bookApptTitle__31-Gv"};